module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('h1', {
    staticClass: "chapter"
  }, [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("HELEN BROOKS")])]), _vm._v(" lives in Northamptonshire, and is married with three children and three beautiful grandchildren. As she is a committed Christian, busy housewife, mother and grandma, her spare time is at a premium, but her hobbies include reading, swimming and gardening, and walks with her husband and their two Irish terriers. Her long-cherished aspiration to write became a reality when she put pen to paper on reaching the age of forty and sent the result off to Mills & Boon.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("Recent titles by the same author:")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("THE BEAUTIFUL WIDOW"), _c('br'), _vm._v("SNOWBOUND SEDUCTION"), _c('br'), _vm._v("SWEET SURRENDER WITH THE MILLIONAIRE"), _c('br'), _vm._v("THE MILLIONAIRE’S CHRISTMAS WIFE"), _c('br'), _vm._v("THE BOSS’S INEXPERIENCED SECRETARY")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_vm._v("Did you know these are also available as eBooks?"), _c('br'), _vm._v("Visit www.Harlequin.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13b6f201","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781460346471_epub_ata_r1.vue
// module id = 60
// module chunks = 0